export const registerServiceWorker = () => {
  if ("serviceWorker" in navigator) {
    console.log("SERVICE WORKER EMPTY");
  } else {
    console.log("SERVICE WORKER NOT IN THE BROWSER");
  }
};
